"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StrategyPosition = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _nanoid = require("nanoid");

var _ = require("../..");

var css = _interopRequireWildcard(require("./StrategyPosition.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * StrategyPosition is a component for positions with options
 *
 * All HTML attributes are supported, and all unhandled props, including refs,
 * are forwarded to the root `StrategyPosition` component.
 */
const StrategyPosition = /*#__PURE__*/React.forwardRef(({
  scripName = '',
  metaTextLeft = '',
  metaTextRight = '',
  primaryInfo = '',
  options,
  trend,
  isSelected = false,
  onClick
}, ref) => (0, _pragma.createFelaElement)(_.Card, {
  ref: ref,
  width: "full"
}, (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  flexDirection: "column",
  onClick: onClick,
  css: css.clickableWrapper
}, (0, _pragma.createFelaElement)(_.View, {
  justifyContent: "space-between",
  padding: [12],
  css: css.positionContainer
}, (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  gap: "xxsmall",
  justifyContent: "center"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "heading3",
  color: "text.1",
  align: "left"
}, scripName), (0, _pragma.createFelaElement)(_.View, {
  gap: "xxsmall"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2",
  align: "left"
}, metaTextLeft), trend)), (0, _pragma.createFelaElement)(_.View, {
  gap: "medium",
  justifyContent: "center",
  alignItems: "center"
}, (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  gap: "xxsmall"
}, (0, _pragma.createFelaElement)(_.View, {
  inline: true,
  justifyContent: "flex-end"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "body",
  color: "text.2",
  align: "right"
}, primaryInfo)), (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2",
  align: "right",
  size: "s"
}, metaTextRight)), (0, _pragma.createFelaElement)(_.ButtonIcon, {
  variant: "invisible"
}, (0, _pragma.createFelaElement)(_.ChevronRightIcon, {
  size: "small",
  color: "text.2"
})))), (0, _pragma.createFelaElement)(_.View, {
  padding: [12],
  gap: "small",
  flexDirection: "column",
  css: css.optionsContainer,
  cssProps: {
    isSelected
  }
}, options.map(item => (0, _pragma.createFelaElement)(_.View, {
  key: (0, _nanoid.nanoid)(),
  flexDirection: "row",
  justifyContent: "space-between"
}, (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "xxsmall",
  alignItems: "flex-start"
}, (0, _pragma.createFelaElement)(_.View, {
  inline: true,
  alignItems: "center"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "metaBold",
  color: "text.1",
  align: "left"
}, item.optionName)), (0, _pragma.createFelaElement)(_.View, {
  inline: true
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2",
  align: "left"
}, item === null || item === void 0 ? void 0 : item.metaTextLeft))), (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  gap: "xxsmall",
  justifyContent: "center"
}, (0, _pragma.createFelaElement)(_.View, {
  inline: true,
  justifyContent: "flex-end"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "bodyBold",
  color: "text.2",
  align: "right"
}, item === null || item === void 0 ? void 0 : item.primaryInfo)), (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2",
  align: "right"
}, item === null || item === void 0 ? void 0 : item.secondaryInfo), (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2",
  align: "right"
}, item === null || item === void 0 ? void 0 : item.metaTextRight))))))));
exports.StrategyPosition = StrategyPosition;
StrategyPosition.displayName = 'StrategyPosition';
var _default = StrategyPosition;
exports.default = _default;
//# sourceMappingURL=StrategyPosition.js.map